import { Users, Info } from 'lucide-react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { SociosEditor } from './socios/SociosEditor';
import { useSocios } from '../hooks/useSocios';
import { useAuthorization } from '@/auth/hooks/useAuthorization';

export function SociosPage() {
  const { socios, isLoading, saveSocios, isSaving } = useSocios();
  const { canEditContabilidad } = useAuthorization();

  if (isLoading) {
    return <div className="p-4 text-sm text-muted-foreground">Cargando...</div>;
  }

  return (
    <div className="space-y-6 p-4">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
          <Users className="size-5" /> Gestión de Socios
        </h2>
        <p className="text-sm text-muted-foreground mt-0.5">Configurá la distribución porcentual de utilidades entre socios</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <SociosEditor
            initialSocios={socios}
            onSave={saveSocios}
            isSaving={isSaving}
            canEdit={canEditContabilidad}
          />
        </div>

        <div className="space-y-4">
          <Card className="shadow-sm border-blue-100 bg-blue-50/30">
            <CardHeader className="pb-2">
              <p className="text-sm font-semibold text-blue-700 flex items-center gap-2">
                <Info className="size-4" /> ¿Cómo funciona?
              </p>
            </CardHeader>
            <CardContent className="text-xs text-blue-800 space-y-2">
              <p>Cada socio tiene un porcentaje asignado que determina su participación en la distribución de utilidades.</p>
              <p>La suma de todos los porcentajes <strong>debe ser exactamente 100%</strong> para poder guardar los cambios.</p>
              <p>Los cambios en socios se reflejan automáticamente en el simulador de reparto del módulo de Utilidad.</p>
            </CardContent>
          </Card>

          <Card className="shadow-sm">
            <CardHeader className="pb-2">
              <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">Resumen</p>
            </CardHeader>
            <CardContent className="space-y-2">
              {socios.map(s => (
                <div key={s.id} className="flex items-center justify-between text-sm">
                  <span className="font-medium">{s.nombre}</span>
                  <span className="text-muted-foreground tabular-nums">{s.porcentaje}%</span>
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
